import {
	AuthProvider as AUTH_PROVIDER,
	Descope as DESCOPE
} from '@descope/react-sdk';
import React, { createContext, useContext } from 'react';
import useDynamicSdk from './useDynamicSdk';

const Context = createContext(undefined);

type SdkVersion = 'v1' | 'v2';

// eslint-disable-next-line react/require-default-props
type ProviderProps = React.ComponentProps<typeof AUTH_PROVIDER> & {
	// eslint-disable-next-line react/require-default-props
	sdkVersion?: SdkVersion;
};

type DescopeProps = React.ComponentProps<typeof DESCOPE>;

type WC = React.DetailedHTMLProps<
	React.HTMLAttributes<HTMLElement>,
	HTMLElement
>;

declare global {
	namespace JSX {
		interface IntrinsicElements {
			'descope-wc-v1': WC;
			'descope-wc-v2': WC;
		}
	}
}

export * from '@descope/react-sdk';

// eslint-disable-next-line react/prop-types
export const AuthProvider = ({
	// eslint-disable-next-line react/prop-types
	projectId,
	sdkVersion,
	...props
}: ProviderProps) => {
	const dynamicSdk = useDynamicSdk({ projectId, sdkVersion });

	return (
		<Context.Provider value={dynamicSdk.sdkVersion + dynamicSdk.projectId}>
			<AUTH_PROVIDER projectId={dynamicSdk.projectId} {...props} />
		</Context.Provider>
	);
};

export const Descope = (props: DescopeProps) => {
	const key = useContext(Context);

	return <DESCOPE {...props} key={key} />;
};
